document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
  var slides = slideshow.querySelectorAll('.diip-story2__slide');
  if (slides.length < 2) return;

  var interval = parseInt(slideshow.getAttribute('data-autoplay'), 10) || 5;
  var current = 0;

  setInterval(function () {
    slides[current].classList.remove('is-active');
    current = (current + 1) % slides.length;
    slides[current].classList.add('is-active');
  }, interval * 1000);
});
